import TableList from "@components/templates/tablelist";
import {
    HttpInsuranceRuleList,
    HttpActiveInsuranceRule
} from "@/service/credit";
import { mapGetters } from "vuex";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpInsuranceRuleList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case "query":
                    this.operate = {
                        show: true,
                        activeid:params,
                        title: "查看",
                        component: "compUpdate",
                        width: 1100,
                        showFooter: false,
                        querytype:'query'
                    };
                    break;
                case "edit":
                    var url = this.$router.resolve({
                        name: "rulescustomerorgUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "add":
                    this.$router.push({
                        name: 'rulescustomerorgUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "active":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { ruleId: params,status:0 },
                        title: "启用",
                        ajaxRequest: HttpActiveInsuranceRule
                    };
                    break;
                case "noactive":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { ruleId: params,status:1 },
                        title: "禁用",
                        ajaxRequest: HttpActiveInsuranceRule
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id,status } = row;
            return [
                {
                    label: "查看详情",
                    params: id,
                    show: true,
                    operate: "query"
                },
                {
                    label: "编辑",
                    params: id,
                    show: true,
                    operate: "edit"
                },
                {
                    label: "启用",
                    params: id,
                    show: status != 0,
                    operate: "active"
                },
                {
                    label: "禁用",
                    params: id,
                    show: status == 0,
                    operate: "noactive"
                },
            ];
        }
    },
    computed: {
        ...mapGetters("dictionary", ["getNextOrgList"]),
        ToolsData() {
            return [
                {
                    label: "添加",
                    operate: "add",
                    theme: "primary"
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: "规则名称",
                    key: 'EQ_ruleName',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "状态",
                    key: 'EQ_status',
                    tag: 'vSelect',
                    options: [
                        { value: 0, label: '启用' },
                        { value: 1, label: '禁用' },
                    ],
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    show: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: "规则名称",
                    key: "ruleName"
                },
                {
                    title: "状态",
                    key: "status",
                    render:(h,{row})=>{
                        return <div>{row.status == 0 ? '启用' : '禁用'}</div>
                    }
                },
                {
                    title: "创建日期",
                    key: "createdAt",
                    sortable: true
                },
            ];
        }
    }
};
